var version = {
    "name":      "dativery",
    "buildDateCode": "20251128-120240",
    "buildDate": "Fri Nov 28 2025 12:02:40 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251128-120240",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;